const style = (theme) => ({
  root: {
    alignItems: 'center',
    marginBottom: theme.spacing(4),
  },
  departmentNameText: {
    fontWeight: 700,
  },
  alignTextEnd: {
    textAlign: 'end',
  },
  ellipsis: {
    whiteSpace: 'noWrap',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '60vw',
  },
})

export default style
